import { useRef } from "react";

export const useDebounce = () => {
    const debounceSeed = useRef(null);

    const debounceFunction = useRef((func, timeout = 200) => {
        if (debounceSeed.current) {
            clearTimeout(debounceSeed.current);
            debounceSeed.current = null;
        }

        debounceSeed.current = setTimeout(() => {
            func();
        }, timeout);
    });

    return debounceFunction.current;
};
